import React from 'react';
import { Link } from 'react-router-dom';
import CourseStep from './CourseStep';
import Badge from './Badge';
import { useAcademy } from '../AcademyContext';
import { IconTrophy, IconArrowRight } from './Icons';

/**
 * Final block at the bottom of the course path: the end result.
 * When all steps are done the bar lights up to congratulate the user, shows the
 * badge they just earned and offers a way back to the course overview.
 */
const CourseResult = ({ isComplete, course, topicId, remaining = 0 }) => {
  const { getBadgeDesign } = useAcademy();
  const badge = course.badge
    ? { ...course.badge, ...getBadgeDesign(course.badge.id) }
    : null;
  const accent = isComplete && badge ? badge.color : undefined;

  return (
    <CourseStep status={isComplete ? 'done' : 'todo'} icon={<IconTrophy size={16} />} isLast>
      <div
        className={`ac-rstep ${isComplete ? 'is-complete' : ''}`}
        style={accent ? { '--bdg-color': accent } : undefined}
      >
        <span className="ac-rstep-badge" style={accent ? { color: accent } : undefined}>
          <IconTrophy size={26} />
        </span>
        <div className="ac-rstep-text">
          <span className="ac-step-kicker">Final result</span>
          {isComplete ? (
            <>
              <h3 className="ac-rstep-title">Congratulations, you made it!</h3>
              <p className="ac-rstep-sub">
                You finished every step and earned a new badge. Great work.
              </p>
              {badge && (
                <div className="ac-rstep-badge-earned">
                  <Badge badge={badge} earned />
                </div>
              )}
            </>
          ) : (
            <>
              <h3 className="ac-rstep-title">Finish all steps to complete</h3>
              <p className="ac-rstep-sub">
                {remaining > 0
                  ? `${remaining} ${
                      remaining === 1 ? 'step' : 'steps'
                    } left above to receive your badge.`
                  : 'Complete every video and exercise above to receive your badge.'}
              </p>
            </>
          )}
        </div>
        {isComplete && topicId && (
          <Link to={`/academy/${topicId}`} className="ac-btn ac-btn-primary ac-rstep-btn">
            Back to all courses <IconArrowRight size={15} />
          </Link>
        )}
      </div>
    </CourseStep>
  );
};

export default CourseResult;
